module.exports = __webpack_public_path__ + "static/media/bg_blur.ba985e1e.jpg";